import getters from './getters';
import actions from './actions';
import mutations from './mutation';

const getDefaultState = () => {
    return {
        blogs: {},
        blogsDetails: {},
        contact_page: '',
        all_campaigns: [],
        campaign_paginate_url:'',
        campaign_paginate_page:1,
        seller_paginate_url:'',
        seller_paginate_page:1,
        brand_paginate_url:'',
        brand_paginate_page:1,

        campaign_products: [],
        campaign_brands:[],
        campaign_shops:[],
        blogCategories:{},
        blogTags:{},
        shop_categories : {},
        shop_brands : {},
        shop_colors : {},
        shop_attributes : [],
        daily_deals : {},
        recent_posts : {},
        product_details: [],
        product_images: {},
        reply_form : {},
        blog_comments : {},
        language_product : {},
        related_products : {},
        compare_list : {},
        product_attributes : {},
        product_attribute_values : {},
        default_form : {},
        product_stocks : {},
        product_colors : {},
        get_page_data:'',
        profile_orders:{},
        userWishlist:{},
        cart_list:{},
        userOrderList:{},
        userCoupons:{},
        wishlist_products:[],
        compare_products:[],
        allWishlist : [],
        default_currency : {},
        get_shop:{},
        carts: [],
        home_components: [],
        home_results: [],
        countCompare: true,
        shimmer:true,
        allCategories:[],
        social_links:[],
        wholesale_prices:[],
        allBrands:[],
        allSellers:[],
        default_assets:{},
        userAddresses:{},
        url: document.getElementById('base_url').value,

        //for filtering
        filter_loaded : false,
        products : [],
        category_products : [],
        brand_products : [],
        seller_products : [],
        offer_products : [],
        selling_products : [],
        category_page : [],
        brand_page : [],
        seller_page : [],
        addons : [],
        wallet_recharges : [],
        order_urls : [],
        invoices : {},
        shop_follwer:[],
        login_redirect:'',
        total_reward : '',
        notifications:[],
        followedSellers:[],
        rewards : [],
        active_modal : '',
        lang_keywords : '',
        shop_contents : [],
        shop_component_names : [],
        common_data:[],
        payment_data : '',
        seller_coupons : [],
        active_tab : 'store',
        price_range : {
            min : 0,
            max : 0,
        },
        countryList : [],
        response_done : [],
        video_shops : [],
        video_details : [],
        slider_banners : [],
        edit_number:'',
        phone:'',
        home_scroller:true,
        sidebar_category: true,
        show_sm_category: false,
    }
}
const state = getDefaultState();
export default {
    // namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
